import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import SessionStatus from './SessionStatus';
import './Dashboard.css';

const Dashboard = () => {
    const [systemStats, setSystemStats] = useState({
        totalUsers: 0,
        totalGroups: 0,
        recentActivity: []
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { logout, isAuthenticated, makeAuthenticatedRequest } = useAuth();    useEffect(() => {
        // Check for JWT token on page load
        if (!isAuthenticated) {
            navigate('/login');
        } else {
            fetchSystemStats();
        }
    }, [navigate, isAuthenticated]);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };    const fetchSystemStats = async () => {
        setLoading(true);
        try {
            // Debug authentication state
            console.log('Dashboard - Authentication Debug:', {
                isAuthenticated,
                hasToken: !!makeAuthenticatedRequest,
                tokenExists: !!localStorage.getItem('jwtToken'),                user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
            });
            
            // Fetch basic system statistics using AuthContext
            const [groupsResponse, usersResponse] = await Promise.all([
                makeAuthenticatedRequest('http://localhost:8000/api/v1/groups'),
                makeAuthenticatedRequest('http://localhost:8000/api/v1/users')
            ]);

            console.log('API Responses:', { groupsResponse, usersResponse });

            let totalGroups = 0;
            let totalUsers = 0;

            if (groupsResponse && groupsResponse.success) {
                const groupsData = groupsResponse.data;
                totalGroups = Array.isArray(groupsData) ? groupsData.length : 0;
            }

            if (usersResponse && usersResponse.success) {
                const usersData = usersResponse.data;
                totalUsers = usersData.data ? usersData.data.length : 0;
            }

            setSystemStats({
                totalUsers,
                totalGroups,
                recentActivity: [
                    { action: 'System Check', timestamp: new Date().toLocaleString() }
                ]
            });
        } catch (error) {
            console.error('Error fetching system stats:', error);
        } finally {
            setLoading(false);
        }
    };

    const navigateToManagement = () => {
        navigate('/management');
    };    return (
        <div className="dashboard">
            {/* Navigation Bar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#!">University Management Dashboard</a>
                    <button 
                        className="navbar-toggler" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="#!" onClick={(e) => {
                                    e.preventDefault();
                                    alert('User Profile link clicked. Implementation pending.');
                                }}>
                                    User Profile
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#!" onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                }}>
                                    Logout
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <div className="container-fluid dashboard-content">
                <div className="row">
                    <div className="col">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h2>Dashboard Overview</h2>
                                <p className="text-muted">Welcome to the University Management System</p>
                            </div>
                            <SessionStatus compact={true} />
                        </div>

                        {/* Statistics Cards */}
                        <div className="row mb-4">
                            <div className="col-md-3 mb-3">
                                <div className="card bg-primary text-white">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="card-title">Total Users</h5>
                                                <h3 className="mb-0">{systemStats.totalUsers}</h3>
                                            </div>
                                            <div className="align-self-center">
                                                <i className="fas fa-users fa-2x"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <div className="card bg-success text-white">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="card-title">Total Groups</h5>
                                                <h3 className="mb-0">{systemStats.totalGroups}</h3>
                                            </div>
                                            <div className="align-self-center">
                                                <i className="fas fa-layer-group fa-2x"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <div className="card bg-info text-white">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="card-title">Applications</h5>
                                                <h3 className="mb-0">--</h3>
                                            </div>
                                            <div className="align-self-center">
                                                <i className="fas fa-file-alt fa-2x"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3">
                                <div className="card bg-warning text-white">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h5 className="card-title">Forms</h5>
                                                <h3 className="mb-0">--</h3>
                                            </div>
                                            <div className="align-self-center">
                                                <i className="fas fa-wpforms fa-2x"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="row mb-4">
                            <div className="col">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="mb-0">Quick Actions</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6 col-lg-3 mb-3">
                                                <button 
                                                    className="btn btn-primary btn-lg w-100"
                                                    onClick={navigateToManagement}
                                                >
                                                    <i className="fas fa-users-cog mb-2"></i>
                                                    <br />
                                                    User & Group Management
                                                </button>
                                            </div>
                                            <div className="col-md-6 col-lg-3 mb-3">
                                                <button 
                                                    className="btn btn-success btn-lg w-100"
                                                    onClick={() => alert('Application Management - Coming Soon!')}
                                                >
                                                    <i className="fas fa-file-signature mb-2"></i>
                                                    <br />
                                                    Application Management
                                                </button>
                                            </div>
                                            <div className="col-md-6 col-lg-3 mb-3">
                                                <button 
                                                    className="btn btn-info btn-lg w-100"
                                                    onClick={() => alert('Form Builder - Coming Soon!')}
                                                >
                                                    <i className="fas fa-edit mb-2"></i>
                                                    <br />
                                                    Form Builder
                                                </button>
                                            </div>
                                            <div className="col-md-6 col-lg-3 mb-3">
                                                <button 
                                                    className="btn btn-warning btn-lg w-100"
                                                    onClick={() => alert('Reports - Coming Soon!')}
                                                >
                                                    <i className="fas fa-chart-bar mb-2"></i>
                                                    <br />
                                                    Reports
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* System Status */}
                        <div className="row">
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="mb-0">System Status</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <button 
                                                className="btn btn-outline-primary"
                                                onClick={fetchSystemStats}
                                                disabled={loading}
                                            >
                                                {loading ? 'Refreshing...' : 'Refresh Stats'}
                                            </button>
                                        </div>
                                        <div className="alert alert-success" role="alert">
                                            <strong>System Status:</strong> All services are running normally.
                                        </div>
                                        <div className="text-muted">
                                            <small>Last updated: {new Date().toLocaleString()}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="mb-0">Recent Activity</h5>
                                    </div>
                                    <div className="card-body">
                                        {systemStats.recentActivity.length > 0 ? (
                                            <ul className="list-unstyled">
                                                {systemStats.recentActivity.map((activity, index) => (
                                                    <li key={index} className="mb-2">
                                                        <small className="text-muted">{activity.timestamp}</small>
                                                        <br />
                                                        {activity.action}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">No recent activity</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
